import { BaseLayoutFactory } from "../global/base-layout-factory";
import { TheCityComponent } from "./the-city-component";

export function TheCityFactory() {
  return (
    <BaseLayoutFactory>
      <TheCityComponent />
    </BaseLayoutFactory>
  );
}
